import { render, staticRenderFns } from "./AccountOrderCreatedNotification.vue?vue&type=template&id=24ac26bf"
import script from "./AccountOrderCreatedNotification.vue?vue&type=script&lang=js"
export * from "./AccountOrderCreatedNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports